import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch } from "react-redux";
import { logout } from "../../reducers/userReducer";
import { useNavigate } from "react-router-dom";
import Paths from "../../router/Paths";

function Header({ transparent }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <div
      className={`w-full  h-12 flex items-center justify-center mb-2 z-50 px-4 py-2 ${
        transparent ? "bg-transparent" : "bg-gray-200"
      } `}
    >
      <div
        onClick={() => {
          navigate(Paths.home);
        }}
      >
        <img src="/logo.svg" alt="" className="h-10 object-contain" />
      </div>
      <div className="w-full max-w-7xl justify-end flex">
        <button
          onClick={() => {
            dispatch(logout());
          }}
        >
          <MenuIcon />
        </button>
      </div>
    </div>
  );
}

export default Header;
